import {
  isTraversalLoadedState,
  LoadedState,
  TraversalLoadedState,
} from '@ardoq/api-types';

export const isSingleTraversalState = (
  loadedStates: LoadedState[]
): loadedStates is [TraversalLoadedState] =>
  loadedStates.length === 1 && isTraversalLoadedState(loadedStates[0]);
